<template> <!-- 用户 虚拟列表 -->
  <ElSelectV2
    v-model="value"
    :multiple="multiple"
    :clearable="clearable"
    :multiple-limit="multipleLimit"
    :loading="loading"
    :options="list"
    filterable
    :placeholder="$t('operationCenter.PleaseSelect')"
    @change="onChange"
  />
</template>

<script>
import ElSelectV2 from 'el-select-v2';
import { scanUserList } from '@/api/lanshou';

export default {
  components: {
    ElSelectV2
  },

  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },

    // 是否可以清空选项
    clearable: {
      type: Boolean,
      default: true
    },

    // 多选时用户最多可以选择的项目数，为 0 则不限制
    multipleLimit: {
      type: Number,
      default: 0
    },

    // id集合 用于回显
    val: {
      type: [Array, String, Number],
      default: () => []
    },

    // 是否显示被禁用人员
    accountState: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      loading: false,
      list: [],
      value: []
    };
  },

  watch: {
    val: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val)) {
          this.value = [...val];
        } else if (typeof val === 'number') {
          this.value = val;
        } else {
          this.value = val || '';
        }
      }
    },

    // 监听 store 中的用户列表变化，实现数据共享
    '$store.state.feesPayable.operatorList': {
      handler(newList) {
        if (newList && newList.length > 0) {
          this.list = newList;
          console.log('从 store 同步用户列表，共', newList.length, '条');
        }
      },
      immediate: false
    }

  },

  created() {
    // 缓存-读取操作人数据
    const list = this.$store.state.feesPayable.operatorList;
    console.log(list, 'user');
    if (list.length > 0) {
      this.list = list;
    } else {
      // 检查是否有正在进行的请求
      const isRequesting = this.$store.state.feesPayable.isOperatorListLoading;

      if (!isRequesting) {
        // 设置加载状态，防止重复请求
        this.$store.commit('feesPayable/SET_OPERATOR_LIST_LOADING', true);
        setTimeout(() => {
          this.asyncGetUserPage();
        }, 100);
      } else {
        // 已有请求在进行中，等待完成后通过 watch 监听 store 变化
        console.log('用户列表加载中，等待缓存更新...');
      }
    }
  },

  methods: {
    // 获取用户信息（含职务）
    asyncGetUserPage() {
      this.loading = true;
      scanUserList({ accountState: this.accountState }, false).then(res => {
        const { code, data } = res;
        if (code !== 200) { return; }

        const list = (data || []).map(item => {
          const { realName, id, organizationName, username } = item;
          return Object.freeze({
            value: id,
            label: `${realName}(${username})`,
            organizationName // 部门
          });
        });

        this.$store.commit('feesPayable/SET_OPERATOR_LIST', list);
        this.$store.commit('feesPayable/SET_OPERATOR_LIST_LOADING', false);
        // window.sessionStorage.setItem(QueryUserV2Cmp, JSON.stringify(list));

        this.list = list;
      }).catch(err => {
        console.error(err);
        this.$store.commit('feesPayable/SET_OPERATOR_LIST_LOADING', false);
      }).finally(() => {
        this.loading = false;
      });
    },

    onChange(val) {
      this.$emit('change', val);
    }
  }
};
</script>
